<template>
  <section>
    <GroupTitle />
    <Feature v-if="isMutiple" :title="$t('GROUP_KEY')" :iconClass="'fa-pencil-square-o'">
      <FormRow :fieldNameArr="[$t('TOTAL') + ': ' + quotationList.length]">
        <Select class="Select"  slot="a" v-model="formNo" @on-change="changeFormNo">
          <Option v-for="(item, index) in quotationList" :value="item.formNo" :key="index">{{ item.formNo }}</Option>
        </Select>
      </FormRow>
    </Feature>
    <Feature :title="$t('MATERIAL_BASIC_INFORMATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo
        :fieldNameArr="[$t('FORM_NO') + ': ', $t('RFQ_TYPE') + ': ', $t('VENDOR_CODE') + ': ', $t('PLANT_CODE') + ': ']"
        :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
        <Input class="Input" v-model="quotation.formNo" slot="a" disabled />
        <Input class="Input" v-model="rfqType" slot="b" disabled />
        <Input class="Input" v-model="quotation.vendorCode" slot="c" disabled />
        <Input class="Input" v-model="quotation.plant" slot="d" disabled />
      </FormRowTwo>
      <FormRowTwo :fieldNameArr="[$t('CURRENCY') + ': ', $t('DELTA_PN') + ': ']" :fieldWidthArr="[364, 364]"
        :fieldSpanWidthArr="[102, 102]">
        <Input class="Input" v-model="quotation.currency" slot="a" disabled />
        <Input class="Input" v-model="quotation.deltaPart" slot="b" disabled />
      </FormRowTwo>
      <FormRowTwo v-if="toolingQuotationFileView" :fieldNameArr="[$t('SPEC_FILE') + ': ']">
      </FormRowTwo>
      <Table v-if="toolingQuotationFileView" width="600" border :columns="fileSchemaList" :data="tooling.attachments">
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" shape="circle" icon="md-download" @click="downloadToolingAttachment(row)"></Button>
        </template>
      </Table>
    </Feature>

    <Feature :title="$t('BUYER')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="[$t('DELTA_BUYER_NAME'), $t('TARGET_PRICE'), $t('EMAIL'), $t('COMMENTS')]"
        :fieldWidthArr="[364, 364, 728]" :fieldSpanWidthArr="[102, 102, 102]">
        <Input class="Input" v-model="cpcAccountName" slot="a" disabled />
        <Input class="Input" v-model="quotation.targetPrice" slot="b" disabled />
        <Input class="Input" style="width: 612px" v-model="quotation.cpcAccountConstactEmail" slot="c" disabled />
      </FormRowTwo>

      <FormRowTwo v-show="hasComments" :fieldNameArr="[$t('COMMENTS') + ': ']" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Button icon="ios-create" slot="a" @click="openComments">{{ $t('COMMENTS') }}</Button>
      </FormRowTwo>

      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('REFERENCE_FILE') + ': ']">
      </FormRowTwo>
      <FormRowTwo v-if="cpcToVendorAttachmentsExited" :fieldNameArr="[$t('')]">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
    </Feature>

    <Feature :title="$t('QUOTATION')" :iconClass="'fa-pencil-square-o'">
      <FormRowTwo :fieldNameArr="['*' + $t('YOUR_PRICE') + ': ', '/1 ' + quotation.unit]" :fieldWidthArr="[364]"
        :fieldSpanWidthArr="[102]">
        <Input class="Input" v-model="price" ref="yourPrice" slot="a" :disabled="!quotation.editable"
          style="border-color:red;border-width:1px;border-style:solid;" />
      </FormRowTwo>
      <FormRowTwo v-if="quotation.editable"
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]"
        :fieldWidthArr="[554, 554]" :fieldSpanWidthArr="[292, 292]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button class="Input" icon="ios-cloud-upload" style="border-color:red;border-width:1px;border-style:solid;">{{
            $t('UPLOAD') }}</Button>
        </Upload>
        <Button class="Input" type="primary" v-show="file !== null" slot="b" @click="uploadFile">{{ $t('CLICK_UPLOAD')
        }}</Button>
      </FormRowTwo>
      <FormRowTwo v-if="supplierAttachmentExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="showSupplierQuotationFiles" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadAttachment(row)"></Button>
            <Button v-if="quotation.editable" type="error" shape="circle" icon="md-close-circle"
              @click="deleteDocument(row)"></Button>
          </template>
        </Table>
      </FormRowTwo>
    </Feature>

    <Feature :title="$t('TOOLING_ATTRIBUTES')" :iconClass="'fa-pencil-square-o'">
      <Card :title="$t('TOOLING_ATTRIBUTES')" class="card-info">
        <FormRowTwo :fieldNameArr="[$t('TOOLING_TYPE') + ': ']" :fieldWidthArr="[364]" :fieldSpanWidthArr="[102]">
          <Input class="Input" v-model="tooling.toolingType" slot="a" disabled />
        </FormRowTwo>
        <FormRow v-if="toolingQuotationType == 'MODIFY'" :fieldNameArr="['*' + $t('MODIFY_DESCRIPTION') + ': ']">
          <Input style="width: 1200px; border-color:red;border-width:1px;border-style:solid;"
            v-model="tooling.modifyDescription" slot="a" type="textarea" :disabled="!quotation.editable" />
        </FormRow>
        <FormRowTwo v-if="toolingQuotationType == 'NEW'"
          :fieldNameArr="['*' + $t('LEAD_TIME') + ': ', isPWB + $t('CAVITY') + ': ', '*' + $t('TOOLING_LIFETIME') + ': ', '*' + $t('CYCLE_TIME') + ': ']"
          :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
          <Input class="Input" v-model="tooling.attribute.leadTime" slot="a" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;">
          <span slot="append">{{ $t('DAYS') }}</span>
          </Input>
          <Input class="Input" v-model="tooling.attribute.cavity" slot="b" :disabled="!quotation.editable"
            :style="isCavity" />
          <Input class="Input" v-model="tooling.attribute.lifeTime" slot="c" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" />
          <Input class="Input" v-model="tooling.attribute.cycleTime" slot="d" :disabled="!quotation.editable"
            style="border-color:red;border-width:1px;border-style:solid;" />
        </FormRowTwo>
        <Card v-if="toolingQuotationType == 'NEW'" :title="$t('BASIC')" class="card-warning mt-3">
          <FormRowTwo
            :fieldNameArr="[$t('LENGTH') + ': ', $t('MACHINE_TONNAGE') + ': ', $t('TOTAL_WEIGHT') + ': ', $t('WIDTH') + ': ']"
            :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
            <Input class="Input" v-model="tooling.attribute.length" slot="a" :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.machineTonnage" slot="b" :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.totalWeight" slot="c" :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.width" slot="d" :disabled="!quotation.editable" />
          </FormRowTwo>
          <FormRowTwo
            :fieldNameArr="[$t('BASE_MATERIAL') + ': ', $t('OTHER_ACCESSORIES') + ': ', $t('HEIGHT') + ': ', $t('MANAGEMENT_PROFIT') + ': ']"
            :fieldWidthArr="[364, 364, 364, 364]" :fieldSpanWidthArr="[102, 102, 102, 102]">
            <Input class="Input" v-model="tooling.attribute.baseMaterial" :maxlength="255" slot="a"
              :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.otherAccessories" :maxlength="255" slot="b"
              :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.height" slot="c" :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.managementProfit" slot="d" :disabled="!quotation.editable" />
          </FormRowTwo>
        </Card>
        <Card v-if="toolingQuotationType == 'NEW'" :title="$t('PRICE')" class="card-warning mt-3">
          <FormRowTwo
            :fieldNameArr="[$t('DESIGN_AND_TESTING_PRICE') + ': ', $t('OTHER_ACCESSORIES_TOTAL_PRICE') + ': ', $t('FORMWORK_PRICE') + ': ']"
            :fieldWidthArr="[444, 444, 444]" :fieldSpanWidthArr="[182, 182, 182]">
            <Input class="Input" v-model="tooling.attribute.designAndTestingPrice" slot="a"
              :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.otherAccessoryTotalPrice" slot="b"
              :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.formworkPrice" slot="c" :disabled="!quotation.editable" />
          </FormRowTwo>
        </Card>
        <Card v-if="toolingQuotationType == 'NEW'" :title="$t('SPECIAL')" class="card-warning mt-3">
          <FormRowTwo :fieldNameArr="[isPLASTIC + $t('COLD_HOT_RUNNER') + ': ', isSTAMPINGOrCONNECTOR + $t('NUMBER_OF_STEP') + ': ',
          isDIECASTING + $t('NUMBER_OF_SLIDER') + ': ', isPACKING + $t('DRY_WET_PRESSURE') + ': ']"
            :fieldWidthArr="[414, 414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152, 152]">
            <Input class="Input" v-model="tooling.attribute.coldHotRunner" :maxlength="255" slot="a"
              :disabled="!quotation.editable" :style="isColdHotRunner" />
            <Input class="Input" v-model="tooling.attribute.numberOfStep" slot="b" :disabled="!quotation.editable"
              :style="isNumberOfStepRequest" />
            <Input class="Input" v-model="tooling.attribute.numberOfSlider" slot="c" :disabled="!quotation.editable"
              :style="isNumberOfSlider" />
            <Input class="Input" v-if="!quotation.editable" v-model="tooling.attribute.dryWetProcess" slot="d"
              :disabled="!quotation.editable" />
            <Select class="Select" v-if="quotation.editable" slot="d" v-model="tooling.attribute.dryWetProcess" clearable
              :style="isDryWetPressure">
              <Option v-for="(item, index) in dryWetProcessList" :value="item" :key="index">
                {{ item }}
              </Option>
            </Select>
          </FormRowTwo>
        </Card>
        <Card v-if="toolingQuotationType == 'MODIFY'" :title="$t('OTHER')" class="card-secondary mt-3">
          <FormRowTwo :fieldNameArr="[$t('OTHER_ACCESSORIES') + ': ', $t('OTHER_ACCESSORIES_TOTAL_PRICE') + ': ']"
            :fieldWidthArr="[414, 414]" :fieldSpanWidthArr="[152, 152]">
            <Input class="Input" v-model="tooling.attribute.otherAccessory" :maxlength="255" slot="a"
              :disabled="!quotation.editable" />
            <Input class="Input" v-model="tooling.attribute.otherAccessoryTotalPrice" slot="b"
              :disabled="!quotation.editable" />
          </FormRowTwo>
        </Card>
        <Card :title="$t('MATERIAL')" class="card-warning mt-3">
          <Table border :columns="materialColumn" :data="tooling.materials"></Table>
        </Card>
        <Card v-if="toolingQuotationType == 'NEW' || toolingQuotationType == 'MODIFY'" :title="$t('MOLDS')"
          class="card-secondary mt-3">
          <FormRowTwo
            :fieldNameArr="[$t('MOLD_MATERIAL') + ': ', $t('MOLD_RAW_MATERIAL_PRICE') + ': ', $t('MOLD_PROCESSING_FEE') + ': ', '']"
            :fieldWidthArr="[414, 414, 414]" :fieldSpanWidthArr="[152, 152, 152]">
            <Input class="Input" v-model="moldMaterial" slot="a" />
            <Input class="Input" v-model="moldRawMeterialPrice" slot="b" />
            <Input class="Input" v-model="moldProcessingFee" slot="c" />
            <Button v-if="quotation.editable" type="primary" @click="addMold" slot="d"> {{ $t('ADD') }}</Button>
          </FormRowTwo>
          <Table v-if="molds.length > 0" border :columns="moldColumn" :data="molds">
            <template slot-scope="{ row }" slot="action">
              <Button v-if="quotation.editable" type="error" shape="circle" icon="md-close-circle"
                @click="deleteMold(row)"></Button>
            </template>
          </Table>
        </Card>
        <Card v-if="toolingQuotationType == 'NEW' || toolingQuotationType == 'MODIFY'" :title="$t('ENGINEERING')"
          class="card-secondary mt-3">
          <FormRowTwo :fieldNameArr="[$t('ENGINEERING_TL_QUANTITY') + ': ', $t('ENGINEERING_WEIGHT') + ': ', '']"
            :fieldWidthArr="[414, 414]" :fieldSpanWidthArr="[152, 152]">
            <Input class="Input" v-model="engineeringTLQuntity" slot="a" />
            <Input class="Input" v-model="engineeringWeight" slot="b" />
            <Button v-if="quotation.editable" type="primary" @click="addEngineering" slot="c">{{ $t('ADD') }}</Button>
          </FormRowTwo>
          <Table v-if="engineerings.length > 0" border :columns="engineeringColumn" :data="engineerings">
            <template slot-scope="{ row }" slot="action">
              <Button v-if="quotation.editable" type="error" shape="circle" icon="md-close-circle"
                @click="deleteEngineering(row)"></Button>
            </template>
          </Table>
        </Card>
      </Card>
    </Feature>

    <ButtonRow>
      <Button v-if="quotation.editable" type="primary" @click="Save" slot="0">{{ $t('SAVE') }}</Button>
      <Button v-if="quotation.editable" type="primary" @click="Submit" slot="1">{{ $t('SUBMIT') }}</Button>
      <Button type="primary" @click="Back" slot="3">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="commentsModal"
      :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo, AlertDelete } from "@/util/alert"
import { CheckCurrency, CheckFloat, CheckNumber, FloraEditorConfig } from "@/util/common"
import { FileSchemaList, ToolingMaterial } from "@/util/tableTitle"
import GroupTitle from "@/views/default/GroupTitle"
import FormRowTwo from '@/components/FormRowTwo'

export default {
  name: "SupplierToolingDetailMaintain",
  components: {
    GroupTitle,
    FormRowTwo
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      comments: '',
      price: '',
      formNo: '',
      uuid: '',
      quotation: {
        cpcAccount: {},
      },
      tooling: {
        attribute: {
        }
      },
      moldMaterial: '',
      moldRawMeterialPrice: '',
      moldProcessingFee: '',
      molds: [],
      engineeringTLQuntity: '',
      engineeringWeight: '',
      engineerings: [],
      rawMaterialList: [],
      file: null,
      supplierQuotationFiles: [],
      showSupplierQuotationFiles: [],
      cpcToVendorAttachments: [],
      loadingStatus: false,
      commentsModal: false,
      fileSchemaList: FileSchemaList(this),
      materialColumn: ToolingMaterial(this),
      dryWetProcessList: [
        "", "DRY", "WET"
      ],
      documentColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('FILE_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'fileName'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          slot: 'action',
          width: 200,
          align: 'center'
        }
      ],
      moldColumn: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_MATERIAL');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'material'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_RAW_MATERIAL_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'rawMaterialPrice'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('MOLD_PROCESSING_FEE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'processingFee'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          slot: 'action',
          width: 100,
          align: 'center'
        }
      ],
      engineeringColumn: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENGINEERING_TL_QUANTITY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'quantity'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ENGINEERING_WEIGHT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'weight'
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          slot: 'action',
          width: 100,
          align: 'center'
        }
      ],
      scalePriceList: []
    }
  },
  created() {
    const vueInstance = this
    vueInstance.toggleLoading(true)
    if (vueInstance.getSupplierQuotationId()) {
      vueInstance.uuid = vueInstance.getSupplierQuotationId()
      vueInstance.formNo = vueInstance.getSupplierFormNo()
      vueInstance.$searchSupplierTooling(vueInstance).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    } else if (vueInstance.getQuotationList().length > 0) {
      vueInstance.formNo = vueInstance.getQuotationList()[0].formNo
      vueInstance.uuid = vueInstance.getQuotationList()[0].uuid
      vueInstance.$searchSupplierTooling(vueInstance).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    } else {
      vueInstance.toggleLoading(false)
      vueInstance.Back()
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getQuotationList", "getSupplierQuotationId", "getSupplierFormNo", "getModalSize"]),
    ...mapActions(["toggleLoading"]),
    changeFormNo() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.$searchSupplierTooling(vueInstance).then(vueInstance => {
        vueInstance.toggleLoading(false)
      })
    },
    openComments() {
      this.commentsModal = true
    },
    downloadAttachment(row) {
      this.$downloadAttachment(this, row.uuid)
    },
    deleteDocument(row) {
      this.supplierQuotationFiles.forEach(attachment => {
        if (attachment.id == row.id) {
          attachment.deleted = true
        }
      })
      this.showSupplierQuotationFiles = this.supplierQuotationFiles.filter(attachment => !attachment.deleted)
    },
    downloadToolingAttachment(row) {
      this.$downloadToolingAttachment(this, this.quotation.uuid, row.uuid)
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadFile() {
      const vueInstance = this
      let fd = new FormData()
      fd.append('file', this.file)
      fd.append('description', "quotaion attachement")
      vueInstance.toggleLoading(true)
      vueInstance.$fileHttp
        .post("/attachment/upload-single?description=quotation" + vueInstance.quotation.formNo, fd)
        .then((response) => {
          vueInstance.supplierQuotationFiles.push(response.data)
          vueInstance.showSupplierQuotationFiles.push(response.data)
          vueInstance.toggleLoading(false)
        })
        .catch(() => { })
    },
    Save() {
      const vueInstance = this
      if (vueInstance.valid(vueInstance)) {
        let data = {
          'currency': this.quotation.currency,
          'price': this.price,
          'supplierQuotationFiles': this.supplierQuotationFiles,
          'uuid': this.quotation.uuid,
          'toolingQuotationDto': vueInstance.tooling
        }
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/update", JSON.stringify(data))
          .then((response) => {
            vueInstance.toggleLoading(false)
          })
          .catch(() => {
            this.toggleLoading(false)
          })
      }
    },
    Submit() {
      const vueInstance = this
      if (vueInstance.valid(vueInstance) && vueInstance.validSupplierAttachments(vueInstance)) {
        let data = {
          'currency': this.quotation.currency,
          'price': this.price,
          'supplierQuotationFiles': this.supplierQuotationFiles,
          'uuid': this.quotation.uuid,
          'toolingQuotationDto': vueInstance.tooling
        }
        vueInstance.toggleLoading(true)
        vueInstance.$quotationHttp
          .post("/supplier/submit", JSON.stringify(data))
          .then((response) => {
            if (vueInstance.getSupplierQuotationId()) {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            } else if (vueInstance.getQuotationList().length > 0) {
              vueInstance.$searchSupplierTooling(vueInstance).then(vueInstance => {
                vueInstance.toggleLoading(false)
              })
            } else {
              vueInstance.toggleLoading(false)
              vueInstance.Back()
            }
          })
          .catch(() => {
            vueInstance.toggleLoading(false)
          })
      }
    },
    addMold() {
      if (this.validMold(this)) {
        this.tooling.attribute.molds.push({
          'material': this.moldMaterial,
          'rawMaterialPrice': this.moldRawMeterialPrice,
          'processingFee': this.moldProcessingFee
        })
        this.molds = this.tooling.attribute.molds
        this.moldMaterial = ''
        this.moldRawMeterialPrice = ''
        this.moldProcessingFee = ''
      }
    },
    validMold(vueInstance) {
      let errorMessage = ""
      if (vueInstance.moldMaterial === "") {
        errorMessage = vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('MOLD_MATERIAL') + " <br>"
      }
      if (vueInstance.moldRawMeterialPrice === "") {
        errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('MOLD_RAW_MATERIAL_PRICE') + " <br>"
      } else if (!CheckFloat(vueInstance.moldRawMeterialPrice)) {
        errorMessage = errorMessage + vueInstance.$t('MOLD_RAW_MATERIAL_PRICE') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
      }
      if (vueInstance.moldProcessingFee === "") {
        errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('MOLD_PROCESSING_FEE') + " <br>"
      } else if (!CheckFloat(vueInstance.moldRawMeterialPrice)) {
        errorMessage = errorMessage + vueInstance.$t('MOLD_PROCESSING_FEE') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
      }

      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => {
        })
      }
      return errorMessage == ""
    },
    addEngineering() {
      if (this.validEngineering(this)) {
        this.tooling.attribute.engineerings.push({
          'weight': this.engineeringWeight,
          'quantity': this.engineeringTLQuntity
        })
        this.engineerings = this.tooling.attribute.engineerings
        this.engineeringTLQuntity = ''
        this.engineeringWeight = ''
      }
    },
    validEngineering(vueInstance) {
      let errorMessage = ""
      if (vueInstance.engineeringWeight === "") {
        errorMessage = vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('ENGINEERING_WEIGHT') + " <br>"
      } else if (!CheckFloat(vueInstance.engineeringWeight)) {
        errorMessage = errorMessage + vueInstance.$t('ENGINEERING_WEIGHT') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
      }
      if (vueInstance.engineeringTLQuntity === "") {
        errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('ENGINEERING_TL_QUANTITY') + " <br>"
      } else if (!CheckFloat(vueInstance.engineeringTLQuntity)) {
        errorMessage = errorMessage + vueInstance.$t('ENGINEERING_TL_QUANTITY') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
      }

      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => { })
      }
      return errorMessage == ""
    },
    deleteMold(row) {
      const vueInstance = this
      AlertDelete(vueInstance, this.$t('IS_DELETE') + row.material)
        .then(() => {
          vueInstance.molds.splice(row, 1)
          if (row.uuid) {
            vueInstance.toggleLoading(true)
            vueInstance.$quotationHttp
              .put("/tooling/delete/moldAttribute/" + row.uuid)
              .then((response) => {
                vueInstance.toggleLoading(false)
              })
              .catch(() => { })
          }
        })
        .catch(() => { })
    },
    deleteEngineering(row) {
      const vueInstance = this
      AlertDelete(vueInstance, this.$t('IS_DELETE'))
        .then(() => {
          vueInstance.engineerings.splice(row, 1)
          if (row.uuid) {
            vueInstance.toggleLoading(true)
            vueInstance.$quotationHttp
              .put("/tooling/delete/engineeringAttribute/" + row.uuid)
              .then((response) => {
                vueInstance.toggleLoading(false)
              })
              .catch(() => { })
          }
        })
        .catch(() => { })
    },
    Back() {
      this.$router.push({ name: 'SUPPLIER_MAINTAIN' })
    },
    valid(vueInstance) {
      let errorMessage = ""

      if (!vueInstance.price) {
        errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN_PRICE') + " <br>"
      } else {
        if (!CheckFloat(vueInstance.price)) {
          errorMessage = errorMessage + vueInstance.$t('PRICE_MUST_BE_NUMBER') + " <br>"
        } else {
          if (Number(vueInstance.price) <= 0) {
            errorMessage = errorMessage + vueInstance.$t('PRICE_MUST_MORE_THAN_ZERO') + " <br>"
          }

          if (CheckCurrency(vueInstance.quotation.currency)) {
            if (vueInstance.price.toString().split("").reverse().join("").indexOf(".") > 4) {
              errorMessage = errorMessage + vueInstance.$t('PRICE_IS_MORE_THAN_FOUR_DIGITS') + " <br>"
            }
          } else {
            if (vueInstance.price.toString().split("").reverse().join("").indexOf(".") > 6) {
              errorMessage = errorMessage + vueInstance.$t('PRICE_IS_MORE_THAN_SIX_DIGITS') + " <br>"
            }
          }
        }
      }

      if (vueInstance.toolingQuotationType == "NEW") {
        if (!vueInstance.tooling.attribute.leadTime) {
          errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('LEAD_TIME') + " <br>"
        } else {
          if (!CheckNumber(vueInstance.tooling.attribute.leadTime)) {
            errorMessage = errorMessage + vueInstance.$t('LEAD_TIME') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
          }
        }

        if (!vueInstance.tooling.attribute.cavity && vueInstance.tooling.toolingType != "PWB") {
          errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('CAVITY') + " <br>"
        } else if (vueInstance.tooling.attribute.cavity) {
          if (!CheckNumber(vueInstance.tooling.attribute.cavity)) {
            errorMessage = errorMessage + vueInstance.$t('CAVITY') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
          }
        }

        if (!vueInstance.tooling.attribute.lifeTime) {
          errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('TOOLING_LIFETIME') + " <br>"
        } else {
          if (!CheckNumber(vueInstance.tooling.attribute.lifeTime)) {
            errorMessage = errorMessage + vueInstance.$t('TOOLING_LIFETIME') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
          }
        }

        if (!vueInstance.tooling.attribute.cycleTime) {
          errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('CYCLE_TIME') + " <br>"
        } else {
          if (!CheckNumber(vueInstance.tooling.attribute.cycleTime)) {
            errorMessage = errorMessage + vueInstance.$t('CYCLE_TIME') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
          }
        }

        if (vueInstance.tooling.attribute.length && !CheckFloat(vueInstance.tooling.attribute.length)) {
          errorMessage = errorMessage + vueInstance.$t('LENGTH') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (vueInstance.tooling.attribute.machineTonnage && !CheckFloat(vueInstance.tooling.attribute.machineTonnage)) {
          errorMessage = errorMessage + vueInstance.$t('MACHINE_TONNAGE') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (vueInstance.tooling.attribute.totalWeight && !CheckFloat(vueInstance.tooling.attribute.totalWeight)) {
          errorMessage = errorMessage + vueInstance.$t('TOTAL_WEIGHT') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (vueInstance.tooling.attribute.width && !CheckFloat(vueInstance.tooling.attribute.width)) {
          errorMessage = errorMessage + vueInstance.$t('WIDTH') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (vueInstance.tooling.attribute.height && !CheckFloat(vueInstance.tooling.attribute.height)) {
          errorMessage = errorMessage + vueInstance.$t('HEIGHT') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (vueInstance.tooling.attribute.managementProfit && !CheckFloat(vueInstance.tooling.attribute.managementProfit)) {
          errorMessage = errorMessage + vueInstance.$t('MANAGEMENT_PROFIT') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (vueInstance.tooling.attribute.designAndTestingPrice && !CheckFloat(vueInstance.tooling.attribute.designAndTestingPrice)) {
          errorMessage = errorMessage + vueInstance.$t('DESIGN_AND_TESTING_PRICE') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (vueInstance.tooling.attribute.otherAccessoryTotalPrice && !CheckFloat(vueInstance.tooling.attribute.otherAccessoryTotalPrice)) {
          errorMessage = errorMessage + vueInstance.$t('OTHER_ACCESSORIES_TOTAL_PRICE') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (vueInstance.tooling.attribute.formworkPrice && !CheckFloat(vueInstance.tooling.attribute.formworkPrice)) {
          errorMessage = errorMessage + vueInstance.$t('FORMWORK_PRICE') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

        if (!vueInstance.tooling.attribute.coldHotRunner && vueInstance.tooling.toolingType == "PLASTIC") {
          errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('COLD_HOT_RUNNER') + " <br>"
        }

        if (!vueInstance.tooling.attribute.numberOfStep && (vueInstance.tooling.toolingType == "STAMPING" || vueInstance.tooling.toolingType == "CONNECTOR")) {
          errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('NUMBER_OF_STEP') + " <br>"
        } else if (vueInstance.tooling.attribute.numberOfStep) {
          if (!CheckFloat(vueInstance.tooling.attribute.numberOfStep)) {
            errorMessage = errorMessage + vueInstance.$t('NUMBER_OF_STEP') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
          }
        }

        if (!vueInstance.tooling.attribute.numberOfSlider && vueInstance.tooling.toolingType == "CAST") {
          errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('NUMBER_OF_SLIDER') + " <br>"
        } else if (vueInstance.tooling.attribute.numberOfSlider) {
          if (!CheckFloat(vueInstance.tooling.attribute.numberOfSlider)) {
            errorMessage = errorMessage + vueInstance.$t('NUMBER_OF_SLIDER') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
          }
        }

        if (!vueInstance.tooling.attribute.dryWetProcess && vueInstance.tooling.toolingType == "PACKING") {
          errorMessage = errorMessage + vueInstance.$t('CHOOSE') + vueInstance.$t('DRY_WET_PRESSURE') + " <br>"
        }
      }

      if (vueInstance.toolingQuotationType == "MODIFY") {
        if (!vueInstance.tooling.modifyDescription) {
          errorMessage = errorMessage + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('MODIFY_DESCRIPTION') + " <br>"
        }
        if (vueInstance.tooling.attribute.otherAccessoryTotalPrice && !CheckFloat(vueInstance.tooling.attribute.otherAccessoryTotalPrice)) {
          errorMessage = errorMessage + vueInstance.$t('OTHER_ACCESSORIES_TOTAL_PRICE') + vueInstance.$t('MUST_BE_NUMBER') + " <br>"
        }

      }

      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => { })
      }
      return errorMessage == ""
    },
    validSupplierAttachments(vueInstance) {
      let errorMessage = ""
      if (vueInstance.showSupplierQuotationFiles.length == 0) {
        errorMessage = vueInstance.$t('PLEASE_UPLOAD_SUPPLIER_ATTACHEMENT') + " <br>"
      }
      if (errorMessage) {
        AlertInfo(vueInstance, errorMessage).then(() => { })
      }
      return errorMessage == ""
    }
  },
  computed: {
    quotationList() {
      return this.getQuotationList()
    },
    isMutiple() {
      return this.getQuotationList() && this.getQuotationList().length > 0
    },
    supplierAttachmentExited() {
      return this.supplierQuotationFiles && this.supplierQuotationFiles.length > 0
    },
    toolingQuotationFileView() {
      return this.tooling.attachments && this.tooling.attachments.length > 0
    },
    rfqType() {
      if (this.quotation.rfqType) {
        return this.quotation.rfqType.description + " (" + this.quotation.toolingQuotationType + ")"
      } else {
        ""
      }
    },
    cpcToVendorAttachmentsExited() {
      return this.cpcToVendorAttachments && this.cpcToVendorAttachments.length > 0
    },
    cpcAccountName() {
      return this.quotation.cpcAccount ? this.quotation.cpcAccount.name : ""
    },
    toolingQuotationType() {
      return this.quotation.toolingQuotationType
    },
    isPWB() {
      return this.tooling.toolingType == "PWB" ? "" : "*"
    },
    isPLASTIC() {
      return this.tooling.toolingType == "PLASTIC" ? "*" : ""
    },
    isSTAMPINGOrCONNECTOR() {
      return (this.tooling.toolingType == "STAMPING" || this.tooling.toolingType == "CONNECTOR") ? "*" : ""
    },
    isDIECASTING() {
      return this.tooling.toolingType == "CAST" ? "*" : ""
    },
    isPACKING() {
      return this.tooling.toolingType == "PACKING" ? "*" : ""
    },
    hasComments() {
      return this.comments != ""
    },
    isColdHotRunner() {
      return this.tooling.toolingType == "PLASTIC" ? "border-color:red;border-width:1px;border-style:solid;" : ""
    },
    isNumberOfStepRequest() {
      return this.tooling.toolingType == "STAMPING" || this.tooling.toolingType == "CONNECTOR" ? "border-color:red;border-width:1px;border-style:solid;" : ""
    },
    isNumberOfSlider() {
      return this.tooling.toolingType == "CAST" ? "border-color:red;border-width:1px;border-style:solid;" : ""
    },
    isDryWetPressure() {
      return this.tooling.toolingType == "PACKING" ? "border-color:red;border-width:1px;border-style:solid;" : ""
    },
    isCavity() {
      return this.tooling.toolingType != "PWB" ? "border-color:red;border-width:1px;border-style:solid;" : ""
    },
    modalSize() {
      return this.getModalSize()
    }
  }
}
</script>

<style scoped></style>
